import { getBrandName } from "../buildUtils"

export const getFlowTypeBasedOnBrand = () => {
    const brand = getBrandName();
    switch (brand) {
        case 'flyin':
            return 'Flyin'
        case 'cleartrip':
            return 'CLEARTRIP'
        default:
            return undefined
    }   
}